export default __webpack_public_path__ + "static/media/clock.2442df33.svg";